"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tooltipPosition = exports.tooltipCaretDirections = exports.tooltipTypes = void 0;
var tooltipTypes = {
  BLACK: 'black'
};
exports.tooltipTypes = tooltipTypes;
var tooltipCaretDirections = {
  TOP: 'top',
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  BOTTOM: 'bottom',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  LEFT: 'left',
  LEFT_BOTTOM: 'left-bottom',
  LEFT_TOP: 'left-top',
  RIGHT: 'right',
  RIGHT_BOTTOM: 'right-bottom',
  RIGHT_TOP: 'right-top'
};
exports.tooltipCaretDirections = tooltipCaretDirections;
var tooltipPosition = {
  ABOVE: 'above',
  ABOVE_LEFT: 'above-left',
  ABOVE_RIGHT: 'above-right',
  BELOW: 'below',
  BELOW_LEFT: 'below-left',
  BELOW_RIGHT: 'below-right',
  LEFT: 'left',
  LEFT_BELOW: 'left-below',
  LEFT_ABOVE: 'left-above',
  RIGHT: 'right',
  RIGHT_BELOW: 'right-below',
  RIGHT_ABOVE: 'right-above'
};
exports.tooltipPosition = tooltipPosition;